import React from "react";
import { WorkflowFooter } from "./WorkflowFooter";

export function StartScreen({ onStart, isLoading, onHome }) {
  return (
    <div className="screen start-screen nx-screen">
      <div className="start-content">

        {/* Nexora logo mark */}
        <div className="nx-start-logo">
          <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polygon
              points="20,4 36,32 4,32"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <line x1="20" y1="14" x2="20" y2="26" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="20" cy="28.5" r="1.2" fill="currentColor"/>
          </svg>
        </div>

        <div className="nx-start-text">
          <h1 className="nx-start-title">End of Day<br/>Report</h1>
          <p className="nx-start-subtitle">
            Answer each question by speaking.<br/>
            Take your time.
          </p>
        </div>

        <div className="nx-start-actions">
          <button
            className="nx-btn nx-btn-gold"
            onClick={onStart}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="btn-loading">
                <span className="nx-spinner" />
                Loading…
              </span>
            ) : (
              "Begin Report"
            )}
          </button>
        </div>

        <p className="nx-start-hint">
          Microphone access required. Please allow when prompted.
        </p>

      </div>

      {/* Workflow navigation — large operational buttons */}
      <WorkflowFooter
        showBack={false}
        onHome={onHome}
        homeLabel="Home"
      />
    </div>
  );
}
